export default "__VITE_ASSET__Cqq3dHX___"